class SvgIcons {
  constructor() {
    this.loadedSvgs = {};
    this.parser = new DOMParser();
    this.observer = new MutationObserver(this.handleMutation.bind(this));

    this.getSvgFile = this.getSvgFile.bind(this);
    this.getViewBox = this.getViewBox.bind(this);
    this.init = this.init.bind(this);
  }

  async getSvgFile(rawUrl) {
    const url = rawUrl.split('#')[0];
    if (!this.loadedSvgs[url]) {
      const svgText = await fetch(url).then((res) => res.text());
      this.loadedSvgs[url] = svgText;
    }
    return Promise.resolve(this.loadedSvgs[url]);
  }

  async getViewBox(symbolId) {
    let symbol;
    if (symbolId.startsWith('#')) {
      symbol = document.querySelector(symbolId);
    } else {
      try {
        const svgText = await this.getSvgFile(symbolId);
        const svgDoc = this.parser.parseFromString(svgText, 'image/svg+xml');
        symbol = svgDoc.getElementById(symbolId.split('#')[1]);
      } catch (err) {
        return null;
      }
    }
    if (!symbol || !symbol.hasAttribute('viewBox')) return null;
    return Promise.resolve(symbol.getAttribute('viewBox'));
  }

  async handleSvgIcon(element) {
    const symbolId = element.getAttribute('href') || element.getAttribute('xlink:href');
    const viewBox = await this.getViewBox(symbolId);
    if (!viewBox) return;
    const parentSvg = element.closest('svg');
    if (!parentSvg) return;
    parentSvg.setAttribute('viewBox', viewBox);
  }

  handleMutation(mutations) {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (node.nodeType === Node.ELEMENT_NODE) {
          // Check if the added node is an SVG with the class 'cukicon'
          if (node.matches && node.matches('svg.cukicon:not([viewBox])')) this.handleSvgIcon(node.querySelector('use'));
          // Also check descendants in case .cukicon is nested deeper
          const cukicons = node.querySelectorAll('svg.cukicon:not([viewBox])');
          cukicons.forEach((element) => this.handleSvgIcon(element.querySelector('use')));
        }
      });
    });
  }

  init() {
    document.querySelectorAll('svg.cukicon:not([viewBox]) use').forEach((use) => this.handleSvgIcon(use));
    this.observer.observe(document.body, {
      childList: true,
      subtree: true,
    });
  }
}

export default new SvgIcons();
